<template>
  <confirm-operation-dialog
    v-model="value"
    title="确认删除"
    @cancel="cancel"
    @confirm="deleteItem"
    :scrollable="item instanceof Array"
    scroll-height="160px"
  >
    <div v-if="item instanceof Array">
      确认删除以下
      <span class="body-2 primary--text px-1">{{item.length}}</span>
      {{itemText? '个' + itemText:'项'}}？
    </div>
    <template v-if="item instanceof Array" slot="scroll">
      <ol class="py-3">
        <li class="ml-2 pl-3" :key="i" v-for="(t, i) in item">{{computedName(t)}}</li>
      </ol>
    </template>
    <div v-else>
      确认删除{{itemText}}
      <span class="body-2 primary--text px-1">{{computedName(item)}}</span>
      ?
    </div>
  </confirm-operation-dialog>
</template>

<script>
import ConfirmOperationDialog from './confirmOperationDialog'

export default {
  name: 'LConfirmDeleteDialog',
  components: {ConfirmOperationDialog},
  props: {
    value: {},
    item: {},
    itemName: {type: String, default: 'name'},
    itemText: {type: String, default: ''},
  },
  computed: {
    computedName () {
      return (o) => {
        if (typeof this.itemName !== 'string') {
          return this.itemName
        }
        let ps = this.itemName.split('.')
        for (let n of ps) {
          if (o instanceof Object) {
            o = o[n]
          }
          else {
            break
          }
        }
        // console.log('name', o)
        return o
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('input', false)
    },
    deleteItem () {
      this.$emit('delete', this.item)
    }
  },
}
</script>

<style scoped>

</style>
